// Bottom strip: where you are in the deck, plus the way into the notes list.
//
// This used to sit at `bottom: 0` behind the formatting toolbar (taller, opaque,
// higher z-index), so it was fully occluded and effectively didn't exist. It now
// sits above the toolbar, carries its own surface, and the entry point is a
// labelled control rather than a bare magnifier — an unlabelled icon plus a
// touch-only swipe gave no indication the notes list existed at all.

export function renderPeekStrip(container, { totalPages, activeIndex, noteCount = 0, onOpenOverview }) {
  const MAX_DOTS = 9;
  const dotCount = Math.min(totalPages, MAX_DOTS);
  const overflow = totalPages > MAX_DOTS;

  // Rendered right-to-left to match the deck, which is mirrored: page 0 (the
  // blank composer) sits at the right end and the index grows leftward. Dots in
  // source order would point the opposite way from the notes they stand for.
  const dotsHtml = Array.from({ length: dotCount }).map((_, i) => `
    <span class="page-dot ${i === activeIndex ? 'active' : ''}"></span>
  `).reverse().join('');

  container.innerHTML = `
    <div class="peek-strip" id="peek-strip-root">
      <div class="page-dots" aria-hidden="true">
        ${overflow ? '<span class="page-dot-more">+</span>' : ''}${dotsHtml}
      </div>

      <button class="all-notes-btn" id="btn-peek-search" type="button"
              aria-label="Show all notes">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="3" width="7" height="7"></rect>
          <rect x="14" y="3" width="7" height="7"></rect>
          <rect x="3" y="14" width="7" height="7"></rect>
          <rect x="14" y="14" width="7" height="7"></rect>
        </svg>
        <span>All notes</span>
        ${noteCount > 0 ? `<span class="all-notes-count">${noteCount}</span>` : ''}
      </button>
    </div>
  `;

  const openBtn = container.querySelector('#btn-peek-search');
  if (openBtn) openBtn.onclick = () => onOpenOverview && onOpenOverview();

  // Swipe up still works on touch, but it's now an accelerator rather than the
  // only way in.
  let startY = 0;
  const peekEl = container.querySelector('#peek-strip-root');
  if (peekEl) {
    peekEl.ontouchstart = (e) => { startY = e.touches[0].clientY; };
    peekEl.ontouchend = (e) => {
      const diffY = startY - e.changedTouches[0].clientY;
      if (diffY > 30 && onOpenOverview) onOpenOverview();
    };
  }
}
